import React from "react"
import clsx from "clsx"
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import DateHelper from "../../DateHelper/DateHelper";

class FormBuilderPreview extends React.Component {

  constructor(props) {
    super(props)
    this.state ={
      test: this.props.form_fields || []
    }
    this.onChangeDate = this.onChangeDate.bind(this);
  }

  render() {
   
    var tabClasses = clsx({
      'active': this.props.active_tab == 'preview',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="preview">
        {this.renderFormFields(this.props.form_fields)}
      </div>
    )
  }

  renderFormFields(form_fields) {  
    var sortedFormFields = []

    if(this.props.order.length > 0) {
      var sortedFormFields = []
      this.props.order.map((position) => {
        form_fields.map((field) => {
          if(field.id == position){
            sortedFormFields.push(field)
          }
        })
      })
    } else {
      sortedFormFields = form_fields
    }
    
    var formFields = sortedFormFields.map((form_field) => {
      var form_field_answer = null
      var number_field_answer = null
      var date_field_answer = null
      var address_field_answer = null
      
      if(this.props.answers) {
        var customerAnswers = this.props.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.number_answer) {
              number_field_answer = answer.number_answer
            } else if(answer.date_answer) {
              date_field_answer = answer.date_answer
            } else if(answer.formatted_address) {
              address_field_answer = answer.formatted_address
            } else {
              form_field_answer = answer.answer
            }
          }
        })
      }

      var customerFieldOptions = form_field.options.map((form_field_option, index) => {
        return <option key={index} value={form_field_option.option}>{form_field_option.option}</option>
      })

      if(form_field.field_type == "text_field_single_line") {
        return (        
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFieldsPreview}  />
            </div>
          </div>  
        )
      }

      if(form_field.field_type == "select_box") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group ">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <select className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : "please_select_one"} onChange={this.props.onChangeFormFieldsPreview} >
                <option value="please_select_one">{I18n.t("select_ellipsis")}</option>
                {customerFieldOptions}
              </select>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "number_input") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <NumberSpinner
                name='number'
                id={form_field.id}
                onChange={this.props.onChangeFormFieldsPreview}
                value={number_field_answer ?  number_field_answer : ""}
                />
            </div>
          </div>
        )
      }

      if(form_field.field_type == "date_form_field") {
        date_field_answer && typeof date_field_answer == 'string' ? date_field_answer = DateHelper.parseDateFromBackend(date_field_answer) : null;
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <DatePickerInput
                selectedDate={date_field_answer}
                dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                customChangeHandler={this.onChangeDate}
                customChangeSource="FormField"
                formFieldID={form_field.id}
                classNames={this.props.errors ? 'has-errors' : false}
              />
            </div>
          </div> 
        )
      }

      if(form_field.field_type == "text_area_multi_line") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <textarea className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFieldsPreview}  />
            </div>
          </div> 
        )
      }

      if(form_field.field_type == "phone_number") {
        return (     
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{I18n.t('mobile_number')}*</label>
              <input type="tel" className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"}  name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFieldsPreview}  />
            </div>
          </div> 
        )
      }

      if(form_field.field_type == "numbered_scale") {
        return (
          <div className="col-sm-4" key={form_field.id} style={{marginBottom: '30px'}}>  
            <label style={{paddingBottom: '20px'}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
            {this.renderRatingRangeForm(form_field)}      
          </div>
        )
      }

      if(form_field.field_type == "emoji_rating") {
        return (
          <div className="col-sm-4" key={form_field.id} style={{marginBottom: '30px'}}>
            <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
            {this.renderEmojiRatingForm(form_field)}        
          </div>
        )
      }

      if(form_field.field_type == "address") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <input  
                type="text" 
                id="autocomplete" 
                name="answers[formatted_address]" 
                value={address_field_answer ?  address_field_answer : ""}
                autoComplete="new-password" 
                className="form-control" 
                onChange={(e) => this.props.onChangeAddress(form_field.id, e)} />
            </div>
          </div>
        )
      }

    });

    return (
      <div className="form-group">
        <img src={this.props.logo_image_url} style={{width: 200, height: 'auto', paddingBottom: '10px', marginBlockStart: '20px'}}></img>
        <br />
        <h4>{this.props.title}</h4>
        <br/>
        <i>{this.props.description}</i>
        <hr/>
        {formFields}  
      </div>
    );
  }

  renderEmojiRatingForm() {

      var rating_range = 5
      var rating_range_arr = []
      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }
      var rating_range_lines = rating_range_arr.map((rating) => {
      
        if(rating_range == 5) {
          if(rating == 1) {

            var list_emoji = <i className="far fa-frown-open fa-2x"></i>
          }
          else if(rating == 2) {

            var list_emoji = <i className="far fa-frown fa-2x"></i>
             
          } else if (rating == 3) {

            var list_emoji = <i className="far fa-meh fa-2x"></i>

          } else if (rating == 4) {

            var list_emoji = <i className="far fa-smile fa-2x"></i>
            
          } else {

            var list_emoji = <i className="far fa-grin fa-2x"></i>

          } 
        }
        
        return (
          <li className={this.props.selected_e == true && this.props.selected_emoji == rating ? `selected-emoji-scale-li` : `emoji-scale-li`}  onClick={() => this.props.onChangeSelectedEmoji(rating)} key={rating}>{list_emoji}</li>
        )
      })
    
    if(this.props.rating_range != 'none') {

      return (
        <ul className="emoji-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 

  }


  renderRatingRangeForm(form_field) {
    if(form_field) {
      var rating_range = parseInt(form_field.rating_range, 10)
      var rating_range_arr = []
      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }
      var rating_range_lines = rating_range_arr.map((rating) => {
        if(rating_range == 10) {

          if(rating <= 3){
            var color = "#aa381d"
          } else if (rating > 3 && rating <= 6) {
            var color = "#d18140"
          } else if (rating > 3 && rating <= 6) {
            var color = "#bba350"
          } else {
            var color = "#61a544"
          }
        }

        if(rating_range == 5) {
          if(rating < 3){
            var color = "#aa381d"
          } else if (rating  == 3) {
            var color = "#bba350"
          } else if (rating > 3 && rating <= 6) {
            var color = "#61a544"
          } else {
            var color = "#61a544"
          }

        }
        
        return (
          <li className={this.props.selected_r == true && this.props.selected_rating == rating ? "selected-rating-scale-li" : "rating-scale-li"}  onClick={() => this.props.onChangeSelectedRating(rating)} key={rating} style={{borderColor: color, color: color}}>{rating}</li>
        )
      })
    }
    if(this.props.rating_range != 'none') {

      return (
        <ul className="rating-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 

  }

  onChangeDate(date, id) {
    this.props.onChangeFormFieldsPreview({
      target: {
        name: 'date',
        value: date,
        id: id
      }
    });
  }
  
}

export default FormBuilderPreview